import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const MarieClaireUS: Site = {
  id: 'marieclaireus',
  logo: 'svg/marieclaire.svg',
  label: 'Marie Claire',
  analyticsName: 'marieclaireus',
  hostname: 'marieclaire.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, .site-content a, #widgetArea12 a.visit-site-test`, // Marie Claire US
};
